import { getMerchantById, Merchant, patchChangeApprovalStatusByMerchantId } from '@nemuru-eng/js-api-client';

import { ActionMessage } from '@/components/widgets/MerchantDetailActions/components/ActionMessage';
import { MerchantDetailAction } from '@/components/widgets/MerchantDetailActions/types/MerchantDetailAction';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const ApproveByCommercialMessage = ({
  merchant,
  opened,
  setOpened,
  handleClose,
}: {
  merchant: Merchant;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}) => {
  const { revalidate } = useCache(getMerchantById, { merchantId: merchant.id });

  const { request, loading } = useRequest();
  const onSubmit = async () => {
    await request(patchChangeApprovalStatusByMerchantId, {
      id: merchant.id,
      isApprovedByCommercial: true,
      isApprovedByRisk: merchant.approvalStatus.isApprovedByRisk,
    });
    handleClose();
    revalidate();
  };

  return (
    <ActionMessage
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      currentAction={MerchantDetailAction.APPROVE_BY_COMMERCIAL}
      onSubmit={onSubmit}
      isLoading={loading}
    />
  );
};
